// @ts-nocheck
export function permissionOverlays() {
  if (!window.plus) return
  if (plus.os.name === 'Android') {
    if (!plus.runtime.permission.isAuthorized(plus.runtime.permission.OVERLAY_WINDOW)) {
      plus.runtime.permission.request(
        plus.runtime.permission.OVERLAY_WINDOW,
        function () {
          // 用户授权成功
        },
        function (e) {
          // 用户拒绝授权
          ElMessage.warning('组队时，建议您在设置中开启悬浮窗权限以降低掉线重连的影响')
        },
      )
    }
  }
}
